import React from "react"

import { WithChildren } from "shared/types/WithChildren"
import { WithClassName } from "shared/types/WithClassName"

import { useLogoSliderViewModel } from "./model/useLogoSliderViewModel"
import "./styles/_logo-slider.scss"
import { LogoSliderView } from "./ui/LogoSliderView"

export interface LogoSliderProps extends WithChildren, WithClassName {
  logoCount: number
  logoWidth?: number
  logoGap?: number
}

export const LogoSlider = React.memo((props: LogoSliderProps) => {
  return <LogoSliderView {...useLogoSliderViewModel(props)} />
})
